// extracted by mini-css-extract-plugin
module.exports = {"body":"TextShowStable_body__2pSu8"};